<app-header></app-header>
<section class="notd__grid note-wrapper wrapper--centered wrapper--organized">
  <div class="note-wrapper__section">
    <div class="note-wrapper__section__threads-links" *ngIf="showPreviousThreadLink || showNextThreadLink">
      <a
        (click)="showNotes('parent')"
        *ngIf="showPreviousThreadLink"
        class="notd__button--v2 bg--transparent"
        title="See previous notes in this thread">See previous notes in this thread</a>
      <a
        (click)="showNotes('children')"
        class="notd__button--v2 bg--transparent"
        *ngIf="showNextThreadLink"
        title="See the next notes in this thread">See the next notes in this thread</a>
    </div>
    <note-detailed-view [note]="note"></note-detailed-view>

    <creator-call-to-action></creator-call-to-action>
    <related-notes *ngIf="note" [tags]="note.tags.join(',')" [rootNote]="note"></related-notes>

  </div>
</section>
<app-footer></app-footer>
